// Launcher tile configuration.
// To enable a new app: set enabled: true and fill in devUrl / prodUrl.
// The portal opens each app via token-passing SSO:
//   {appUrl}/sso?token={JWT}&u={base64(userJson)}
// The target app must have an /sso route that stores the token and redirects.

// Where the LAUNCHED apps live (not where the portal runs).
// The portal launches DEPLOYED apps, so default to 'prod'.
// Set to 'dev' only if you also run each target app locally (localhost:3000 etc).
const TARGET = 'prod';

export const APPS = [
  {
    key: 'devops',
    name: 'DevOps Center',
    description: 'Pipelines, deployments & CF apps',
    icon: '🔧',
    color: '#1a56db',
    enabled: true,
    devUrl: 'http://localhost:3000',
    prodUrl: 'https://devops.cloudleaders.co.in',
    // Optional: only show tile to certain roles. Empty = all roles.
    roles: [],
  },
  {
    key: 'pm',
    name: 'PM Center',
    description: 'Projects, tasks, milestones & Gantt',
    icon: '📋',
    color: '#7c3aed',
    enabled: true,
    devUrl: 'http://localhost:3001',
    prodUrl: 'https://pm.cloudleaders.co.in',
    roles: [],
  },
  {
    key: 'support',
    name: 'Support Center',
    description: 'Tickets & customer support',
    icon: '🎧',
    color: '#ea580c',
    enabled: true, // Support Center is deployed with an /sso route
    devUrl: 'http://localhost:3004',
    prodUrl: 'https://support.cloudleaders.co.in',
    roles: [],
  },
  {
    key: 'products',
    name: 'CLTS Products',
    description: 'Cloud Leaders products & solutions',
    icon: '📦',
    color: '#059669',
    enabled: true,
    productsCard: true, // opens the in-portal products list instead of redirecting
    roles: [],
  },
];

// Optional static products. Products are now maintained in PM Center as projects with
// category "Product" (each with a Live URL) and fetched dynamically at
// /api/pm-projects?category=Product — so this stays empty by default.
export const PRODUCTS = [];

export function appUrl(app) {
  return TARGET === 'dev' ? app.devUrl : app.prodUrl;
}

// Apps a user may see on the launcher: ADMIN sees all; a blank allowlist = all
// (grandfather); otherwise only the apps listed in user.apps.
export function visibleAppsFor(user) {
  const userApps = (user.apps || '').split(',').map(s => s.trim()).filter(Boolean);
  const isAdmin = user.role === 'ADMIN';
  return APPS.filter(a => isAdmin || userApps.length === 0 || userApps.includes(a.key));
}

// Of those, the ones that actually launch somewhere (enabled, not the in-portal
// products card). Used to decide whether to skip the launcher for single-app users.
export function launchableAppsFor(user) {
  return visibleAppsFor(user).filter(a => a.enabled && !a.productsCard);
}

// The URL to send the user to for an app: external apps open directly; CLTS apps
// get the token-passing SSO handoff at their /sso route.
export function launchUrl(app, token, user) {
  if (app.external) return appUrl(app);
  const payload = btoa(encodeURIComponent(JSON.stringify(user)));
  return `${appUrl(app)}/sso?token=${encodeURIComponent(token)}&u=${payload}`;
}
